import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { connect } from "formik";
import cl from "classnames";

import SharedLayoutOptions from "venuescanner-js/react/components/LayoutOptions";

import classes from "../../styles/styles.module.scss";
import stage1Classes from "../../styles/guestsAndLayout.scss";

const RangeInput = ({ onChange, value, ...props }) => {
  const emit = useCallback(
    ({ target: { value: val } }) => {
      onChange(parseInt(val, 10) || 0);
    },
    [onChange]
  );

  return (
    <div className={classes.RangeInputWrapper}>
      <input
        min="1"
        step="1"
        className={classes.RangeInput}
        type="number"
        defaultValue={value}
        onChange={emit}
        {...props}
      />
      <span>guests</span>
    </div>
  );
};

RangeInput.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.number,
};

const GUESTS_NAME = "guests";
const GuestsSlider = connect(({ formik: { setFieldValue, values } }) => (
  <div className={classes.FieldWrapper}>
    <p>How many people are coming?</p>
    <RangeInput
      value={values[GUESTS_NAME]}
      onChange={(val) => {
        setFieldValue(GUESTS_NAME, val);
        window.dataLayer.push({ event: GUESTS_NAME });
      }}
    />
  </div>
));

const LAYOUT_NAME = "layout";
const LayoutOptionsList = connect(({ formik }) => (
  <SharedLayoutOptions
    value={formik.values[LAYOUT_NAME] || []}
    onChange={(newValue) => {
      formik.setFieldValue(LAYOUT_NAME, newValue);
      window.dataLayer.push({ event: LAYOUT_NAME });
    }}
  />
));

const LayoutOptions = () => (
  <div className={cl(stage1Classes.LayoutOptions, classes.FieldWrapper)}>
    <p>What's your preferred layout?</p>
    <div className={stage1Classes.LayoutOptionsContainer}>
      <LayoutOptionsList />
    </div>
  </div>
);

const GuestsAndLayoutStage = () => (
  <div className={classes.Form}>
    <div className={classes.StageWrapper}>
      <GuestsSlider />
      <LayoutOptions />
    </div>
  </div>
);

export default GuestsAndLayoutStage;
